const users = [
  {
    id: '5e86809283e28b96d2d38537',
    email: 'info@wace.me',
    password: '123456',
    name: 'JWT User'
  }
];

export default users;
